import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { AuthErrorCode } from '../enums/auth-error-code';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  public topMessage: string;
  public bottomMessage: string;
  public link: string;

  public constructor(private readonly router: Router) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public showLoginError(error: any): void {
    if (error?.errorCode === AuthErrorCode.invalid_client && (error?.errorMessage ?? '').includes('1fd5118e-2576-4263-8130-9503064c837a')) {
      return this.showError(
        TranslationKeys.AssistantWarningLoginFailedPrincipalAcs,
        TranslationKeys.WarningContactYourAdministrator,
        'https://learn.microsoft.com/en-us/azure/communication-services/quickstarts/manage-teams-identity?pivots=programming-language-csharp#step-5-provide-administrator-consent',
      );
    }
    this.showError(TranslationKeys.AssistantWarningLoginFailed, TranslationKeys.WarningContactYourAdministrator);
  }

  public showError(topMessage: string, bottomMessage: string, link: string = ''): void {
    this.topMessage = topMessage;
    this.bottomMessage = bottomMessage;
    this.link = link;
    this.router.navigate(['error']);
  }
}
